import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import PrivateRoutes from "./auth/routes/PrivateRoutes";
import ErrorPage from "./pages/ErrorPage";
import theme from "./config/theme";
import { ThemeProvider } from "@mui/material";
import PanelPage from "./pages/PanelPage";
import AuthPage from "./pages/AuthPage";
import axios from "axios";

export const apiUrl = process.env.REACT_APP_API_URL;
export const isNeedToSecure = process.env.REACT_APP_IS_NEED_TO_SECURE;

axios.defaults.withCredentials = true;

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<Navigate to="/admin/panel" replace />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route element={<PrivateRoutes />}>
                        <Route path="/admin/panel/*" element={<PanelPage />} />
                    </Route>
                    <Route path="/admin/error" element={<ErrorPage />} />
                    <Route path="*" element={<Navigate to="/admin/error?status=404" />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;
